import { createAction, props } from '@ngrx/store'
import { RequestModel, LocationModel, ContactQueuesModel, CampaignMetricsPerLocationModel, IncomingReviewSeriesModel, SentVsPendingModel, FinishCampaignModel } from '@models/index'

export const setBusinessDashboardLocation = createAction(
    '[Dashboards page] Set Business Dashboard Location',
    props<{ location: LocationModel }>()
)

export const searchBusinessReviewsByLocation = createAction(
    '[Dashboards page] Search Business Reviews By Location',
    props<{ request: RequestModel }>()
)

export const searchBusinessReviewsAmountByLocation = createAction(
    '[Dashboards page] Search Business Reviews Amount By Location',
    props<{ request: RequestModel }>()
)

export const searchBusinessReviewsAmountByLocationSuccess = createAction(
    '[Dashboards page] Search Business Reviews Amount By Location Success',
    props<{ businessDashboardReviewsAmount: number }>()
)

export const searchBusinessFeedbacksAmountByLocation = createAction(
    '[Dashboards page] Search Business Feedbacks Amount By Location',
    props<{ request: RequestModel }>()
)

export const searchBusinessFeedbacksAmountByLocationSuccess = createAction(
    '[Dashboards page] Search Business Feedbacks Amount By Location Success',
    props<{ businessDashboardFeedbacksAmount: number }>()
)

export const searchBusinessContactsAmountByLocation = createAction(
    '[Dashboards page] Search Business Contacts By Location',
    props<{ request: RequestModel }>()
)

export const searchBusinessContactsAmountByLocationSuccess = createAction(
    '[Dashboards page] Search Business Contacts By Location Success',
    props<{ businessDashboardContactsAmount: number }>()
)

export const searchLocationContactsQueues = createAction(
    '[Dashboards page] Search Location Contacts Queues',
    props<{ request: RequestModel }>()
)

export const searchLocationContactsQueuesSuccess = createAction(
    '[Dashboards page] Search Location Contacts Queues Success',
    props<{ locationQueues: ContactQueuesModel }>()
)

export const searchLocationCampaignMetrics = createAction(
    '[Dashboards page] Search Location Campaigns Metrics',
    props<{ request: RequestModel }>()
)

export const searchLocationCampaignMetricsSuccess = createAction(
    '[Dashboards page] Search Location Campaigns Metrics Success',
    props<{ locationCampaignMetrics: CampaignMetricsPerLocationModel }>()
)

export const searchLocationTodaySeries = createAction(
    '[Dashboards page] Search Location Today Series',
    props<{ request: RequestModel }>()
)

export const searchLocationTodaySeriesSuccess = createAction(
    '[Dashboards page] Search Location Today Series Success',
    props<{ locationTodaySeries: IncomingReviewSeriesModel }>()
)

export const searchLocationLastWeekSeries = createAction(
    '[Dashboards page] Search Location Last Week Series',
    props<{ request: RequestModel }>()
)

export const searchLocationLastWeekSeriesSuccess = createAction(
    '[Dashboards page] Search Location Last Week Series Success',
    props<{ locationLastWeekSeries: IncomingReviewSeriesModel }>()
)

export const searchLocationLastMonthSeries = createAction(
    '[Dashboards page] Search Location Last Month Series',
    props<{ request: RequestModel }>()
)

export const searchLocationLastMonthSeriesSuccess = createAction(
    '[Dashboards page] Search Location Last Month Series Success',
    props<{ locationLastMonthSeries: IncomingReviewSeriesModel }>()
)

export const searchLocationReviewRequestTodaySeries = createAction(
    '[Dashboards page] Search Location Review Request Today Series',
    props<{ request: RequestModel }>()
)

export const searchLocationReviewRequestTodaySeriesSuccess = createAction(
    '[Dashboards page] Search Location Review Request Today Series Success',
    props<{ locationTodaySeries: IncomingReviewSeriesModel }>()
)

export const searchLocationReviewRequestLastWeekSeries = createAction(
    '[Dashboards page] Search Location Review Request Last Week Series',
    props<{ request: RequestModel }>()
)

export const searchLocationReviewRequestLastWeekSeriesSuccess = createAction(
    '[Dashboards page] Search Location Review Request Last Week Series Success',
    props<{ locationLastWeekSeries: IncomingReviewSeriesModel }>()
)

export const searchLocationReviewRequestLastMonthSeries = createAction(
    '[Dashboards page] Search Location Review Request Last Month Series',
    props<{ request: RequestModel }>()
)

export const searchLocationReviewRequestLastMonthSeriesSuccess = createAction(
    '[Dashboards page] Search Location Review Request Last Month Series Success',
    props<{ locationLastMonthSeries: IncomingReviewSeriesModel }>()
)

export const searchLocationSentVsPending= createAction(
    '[Dashboards page] Search Location Sent vs Pending',
    props<{ request: RequestModel }>()
)

export const searchLocationSentVsPendingSuccess = createAction(
    '[Dashboards page] Search Location Sent vs Pending Success',
    props<{ locationSentVsPending: SentVsPendingModel }>()
)

export const searchLocationFinishCampaign= createAction(
    '[Dashboards page] Search Location Finish Campaign',
    props<{ request: RequestModel }>()
)

export const searchLocationFinishCampaignSuccess = createAction(
    '[Dashboards page] Search Location Finish Campaign Success',
    props<{ locationFinishCampaign: FinishCampaignModel }>()
)

export const getBusinessRating = createAction(
    '[Dashboards Page] Get Business Rating',
    props<{ request: RequestModel }>()
)

export const getBusinessRatingSuccess = createAction(
    '[Dashboards Page] Get Business Rating Success',
    props<{ businessRating: number }>()
)

export const getBusinessStarsCount = createAction(
    '[Dashboards Page] Get Business Stars Count',
    props<{ request: RequestModel }>()
)

export const getBusinessStarsCountSuccess = createAction(
    '[Dashboards Page] Get Business Stars Count Success',
    props<{ businessStarsCount: number[] }>()
)

export const getBusinessReviewCount = createAction(
    '[Dashboards Page] Get Business Review Count',
    props<{ request: RequestModel }>()
)

export const getBusinessReviewCountSuccess = createAction(
    '[Dashboards Page] Get Business Review Count Success',
    props<{ businessReviewCount: number }>()
)

export const getBusinessUserCount = createAction(
    '[Dashboards Page] Get Business User Count',
    props<{ request: RequestModel }>()
)

export const getBusinessUserCountSuccess = createAction(
    '[Dashboards Page] Get Business User Count Success',
    props<{ businessUserCount: number }>()
)

export const getBusinessContactCount = createAction(
    '[Dashboards Page] Get Business Contact Count',
    props<{ request: RequestModel }>()
)

export const getBusinessContactCountSuccess = createAction(
    '[Dashboards Page] Get Business Contact Count Success',
    props<{ businessContactCount: number }>()
)

export const getBusinessLocationCount = createAction(
    '[Dashboards Page] Get Business Location Count',
    props<{ request: RequestModel }>()
)

export const getBusinessLocationCountSuccess = createAction(
    '[Dashboards Page] Get Business Location Count Success',
    props<{ businessLocationCount: number }>()
)

export const getLastDayReviewCount = createAction(
    '[Dashboards Page] Get Last Day Review Count',
    props<{ request: RequestModel }>()
)

export const getLastDayReviewCountSuccess = createAction(
    '[Dashboards Page] Get Last Day Review Count Success',
    props<{ lastDayReviewCount: number }>()
)

export const getLastWeekReviewCount = createAction(
    '[Dashboards Page] Get Last Week Review Count',
    props<{ request: RequestModel }>()
)

export const getLastWeekReviewCountSuccess = createAction(
    '[Dashboards Page] Get Last Week Review Count Success',
    props<{ lastWeekReviewCount: number }>()
)

export const getLastMonthReviewCount = createAction(
    '[Dashboards Page] Get Last Month Review Count',
    props<{ request: RequestModel }>()
)

export const getLastMonthReviewCountSuccess = createAction(
    '[Dashboards Page] Get Last Month Review Count Success',
    props<{ lastMonthReviewCount: number }>()
)

export const getResellerBusinessCount = createAction(
    '[Dashboards Page] Get Reseller Business Count',
    props<{ request: RequestModel }>()
)

export const getResellerBusinessCountSuccess = createAction(
    '[Dashboards Page] Get Reseller Business Count Success',
    props<{ resellerBusinessCount: number }>()
)

export const getResellerUserCount = createAction(
    '[Dashboards Page] Get Reseller User Count',
    props<{ request: RequestModel }>()
)

export const getResellerUserCountSuccess = createAction(
    '[Dashboards Page] Get Reseller User Count Success',
    props<{ resellerUserCount: number }>()
)

export const getResellerLocationCount = createAction(
    '[Dashboards Page] Get Reseller Location Count',
    props<{ request: RequestModel }>()
)

export const getResellerLocationCountSuccess = createAction(
    '[Dashboards Page] Get Reseller Location Count Success',
    props<{ resellerLocationCount: number }>()
)

export const getSiteAdminResellerCount = createAction(
    '[Dashboards Page] Get Site Admin Reseller Count',
    props<{ request: RequestModel }>()
)

export const getSiteAdminResellerCountSuccess = createAction(
    '[Dashboards Page] Get Site Admin Reseller Count Success',
    props<{ siteAdminResellerCount: number }>()
)

export const getSiteAdminBusinessCount = createAction(
    '[Dashboards Page] Get Site Admin Business Count',
    props<{ request: RequestModel }>()
)

export const getSiteAdminBusinessCountSuccess = createAction(
    '[Dashboards Page] Get Site Admin Business Count Success',
    props<{ siteAdminBusinessCount: number }>()
)

export const getSiteAdminUserCount = createAction(
    '[Dashboards Page] Get Site Admin User Count',
    props<{ request: RequestModel }>()
)

export const getSiteAdminUserCountSuccess = createAction(
    '[Dashboards Page] Get Site Admin User Count Success',
    props<{ siteAdminUserCount: number }>()
)

export const getSiteAdminLocationCount = createAction(
    '[Dashboards Page] Get Site Admin Location Count',
    props<{ request: RequestModel }>()
)

export const getSiteAdminLocationCountSuccess = createAction(
    '[Dashboards Page] Get Site Admin Location Count Success',
    props<{ siteAdminLocationCount: number }>()
)

export const dashboardsError = createAction(
    '[Dashboards Page] Dashboards Error',
    props<{ error: string }>()
)
